var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetvideo = function SvgAssetvideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 26 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#329432",
    strokeLinecap: "round",
    strokeWidth: 1.75,
    d: "M11.375 5.541h2.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#329432",
    strokeWidth: 1.75,
    d: "M.875 9.042c0-3.85 0-5.775 1.196-6.971S5.19.875 9.04.875h1.167c3.85 0 5.775 0 6.971 1.196s1.196 3.12 1.196 6.97v2.334c0 3.85 0 5.775-1.196 6.97-1.196 1.197-3.12 1.197-6.97 1.197H9.041c-3.85 0-5.775 0-6.971-1.196S.875 15.225.875 11.375z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#329432",
    strokeLinecap: "round",
    strokeWidth: 1.75,
    d: "m18.375 6.598.147-.121c2.469-2.037 3.703-3.056 4.695-2.563.991.49.991 2.122.991 5.381v1.825c0 3.26 0 4.89-.991 5.382-.992.491-2.226-.526-4.695-2.563l-.147-.122"
  })));
};
export default SvgAssetvideo;